import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { StrutturaProspettoDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class StrutturaProspettoApiClient extends BaseCRUDApiClient<StrutturaProspettoDto> {
  baseUrl = this.config.apiEndpoint + '/struttura-prospetto';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
